import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import CustomButton from '../Button/Button';

const styles = {
    buttonSection: {
        display: 'flex',
        padding: '14px',
    },
    buttonLeft: {
        marginLeft: 'auto',
    },
    buttonRight: {
        marginLeft: '15px',
    },
};


const ActionButtons = ({
    cancel,
    cancelColor = 'secondary',
    cancelText = 'Cancel',
    classes,
    colorSubmit = 'primary',
    disabledCancel = false,
    disabledSubmit,
    size = 'medium',
    submit,
    submitText = 'OK',
}) => (
    <div className={classes.buttonSection}>
        <CustomButton
            className={classes.buttonLeft}
            color={colorSubmit} size={size}
            disabled={disabledSubmit}
            onClick={submit}
            variant="contained"
        >
            {submitText}
        </CustomButton>
        <CustomButton
            className={classes.buttonRight}
            color={cancelColor}
            disabled={disabledCancel}
            onClick={cancel}
            size={size}
            variant="contained"
        >
            {cancelText}
        </CustomButton>
    </div>
);

export default withStyles(styles)(ActionButtons);
